const COOKIE_KEY = {
  USERNAME: "web_userName",
  PERMISSIONID: "web_permissionId",
  PERMISSION1: "web_permission1",
  PERMISSION2: "web_permission2",
  PERMISSION3: "web_permission3",
  BRANCHCODE: "web_branchCode",
  BRANCHNAME: "web_branchName",
  BRANCHFURNACES: "web_branchFurnaces",
  BRANCHFUNENWEEK: "web_branchFunenWeek",
};

/**
 * Cookie情報操作
 * @returns
 */
export default function useCookie() {
  const cookies = {};
  document.cookie.split("; ").forEach(c => {
    const [k, v] = c.split("=");
    cookies[k] = decodeURIComponent(v);
  });
  const branchCode = cookies[COOKIE_KEY.BRANCHCODE];
  const branchName = cookies[COOKIE_KEY.BRANCHNAME];
  const branchFurnaces = cookies[COOKIE_KEY.BRANCHFURNACES];
  const branchFunenWeek = cookies[COOKIE_KEY.BRANCHFUNENWEEK];
  const userName = cookies[COOKIE_KEY.USERNAME];
  const permissionId = cookies[COOKIE_KEY.PERMISSIONID];
  const permission1 = cookies[COOKIE_KEY.PERMISSION1];
  const permission2 = cookies[COOKIE_KEY.PERMISSION2];
  const permission3 = cookies[COOKIE_KEY.PERMISSION3];

  // Cookieを登録
  const setCookie = (key: string, value: string | number) => {
    document.cookie = `${key}=${encodeURIComponent(value)}; path=/`;
  };
  const setCookies = (
    branchCode: string,
    branchName: string,
    branchFurnaces: number,
    branchFunenWeek: string,
    userName: string,
    permissionId: number,
    permission1: number,
    permission2: number,
    permission3: number
  ) => {
    setCookie(COOKIE_KEY.BRANCHCODE, branchCode);
    setCookie(COOKIE_KEY.BRANCHNAME, branchName);
    setCookie(COOKIE_KEY.BRANCHFURNACES, branchFurnaces);
    setCookie(COOKIE_KEY.BRANCHFUNENWEEK, branchFunenWeek);
    setCookie(COOKIE_KEY.USERNAME, userName);
    setCookie(COOKIE_KEY.PERMISSIONID, permissionId);
    setCookie(COOKIE_KEY.PERMISSION1, permission1);
    setCookie(COOKIE_KEY.PERMISSION2, permission2);
    setCookie(COOKIE_KEY.PERMISSION3, permission3);
  };

  // Cookieを削除
  const deleteCookie = (key: string) => {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  };
  function deleteCookies() {
    Object.values(COOKIE_KEY).forEach(deleteCookie);
  }

  return [
    {
      branchCode,
      branchName,
      branchFurnaces,
      branchFunenWeek,
      userName,
      permissionId,
      permission1,
      permission2,
      permission3,
    },
    { setCookies, deleteCookies },
  ];
}
